import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Component, OnInit } from '@angular/core';
import {
  ConfigService,
  DataShareService,
  OntologyResponse,
  SurfAuthorizationService,
  SurfCalendarStartDateService,
  SurfCriteriaUtil, SurfStaticDataService, SurfTourUtilService,
  SurfTravellerEarliestDepartureDateService,
  SurfUtilService,
  SurfVisibilityConfigService
} from '@surf/surf-components-core';
import { DataServiceHandler } from '@tc-core/service/service-handlers';
import { ConfigLoader, DataStore } from '@tc-core/util/framework';
import { TourCriteriaComponent } from '../tour-criteria/tour-criteria.component';

@Component({
  selector: 'surf-tour-criteria-dp',
  templateUrl: './tour-criteria-dp.component.html'
})
export class TourCriteriaDpComponent extends TourCriteriaComponent implements OnInit {

  constructor(
    protected commonService: DataShareService,
    protected dataServiceHandler: DataServiceHandler,
    protected surfStaticDataService: SurfStaticDataService,
    protected configService: ConfigService,
    protected surfUtilService: SurfUtilService,
    public surfCriteriaUtil: SurfCriteriaUtil,
    protected configLoader: ConfigLoader,
    protected surfCalendarStartDateService: SurfCalendarStartDateService,
    protected surfTourUtilService: SurfTourUtilService,
    protected datastore: DataStore,
    protected surfAuthorizationService: SurfAuthorizationService,
    protected travellerEarliestDepartureDateService: SurfTravellerEarliestDepartureDateService,
    protected surfVisibilityConfigService: SurfVisibilityConfigService
  ) {
    super(
      commonService,
      dataServiceHandler,
      surfStaticDataService,
      configService,
      surfUtilService,
      surfCriteriaUtil,
      configLoader,
      surfCalendarStartDateService,
      surfTourUtilService,
      datastore,
      surfAuthorizationService,
      travellerEarliestDepartureDateService,
      surfVisibilityConfigService
    );
  }

  ngOnInit() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria-dp/tour-criteria-dp.component.ts.TourCriteriaDpComponent.ngOnInit');
    super.ngOnInit();
  }

}
